import {lazy} from "react";

export const LazyComingSoonPage = lazy(() =>
    import('./pages/coming-soon').then((module) => ({
        default: module.ComingSoon,
    })),
);
export const OurFarmsPage = lazy(() =>
    import("./pages/farms").then((module) => ({
        default: module.OurFarms,
    }))
);
export const BlogPage = lazy(() =>
    import("./pages/blog/blog").then((module) => ({
        default: module.Blog,
    }))
);
export const BlogContentPage = lazy(() =>
    import("./pages/blogContent").then((module) => ({
        default: module.BlogContent,
    }))
);
export const LazyPrivacyPolicy = lazy(() =>
    import("./pages/privacy-policy").then((module) => ({
        default: module.PrivacyPolicyPage,
    }))
);
export const LazyRefundPolicy = lazy(() =>
    import("./pages/refund-policy").then((module) => ({
        default: module.RefundPolicy,
    }))
);
export const LazyTermsAndConditions = lazy(() =>
    import("./pages/terms-and-conditions").then(
        (module) => ({
            default: module.TermsAndConditions,
        })
    )
);
export const OurFarmPopUp = lazy(() =>
    import("./pages/farms/pages/ourFarmPopUp").then((module) => ({
        default: module.OurFarmPopUp,
    }))
);
export const SignInPage = lazy(() =>
    import("./pages/signIn/signIn.page").then((module) => ({
        default: module.SignInPage,
    }))
);
export const CreateAccountPage = lazy(() =>
    import("./pages/createAccount/create-account.page").then((module) => ({
        default: module.CreateAccountPage,
    }))
);
export const CreateFarmAccountPage = lazy(() =>
    import("./pages/createFarmAccount/createFarmAccount.page").then((module) => ({
        default: module.CreateFarmAccountPage,
    }))
);
export const ResetPasswordPage = lazy(() =>
    import("./pages/resetPassword/resetPassword.page").then((module) => ({
        default: module.ResetPasswordPage,
    }))
);
export const VerifyResetPasswordPage = lazy(() =>
    import("././pages/verifyResetPassword/verifyResetPassword.page").then((module) => ({
        default: module.VerifyResetPasswordPage,
    }))
);
export const ChangePasswordPage = lazy(() =>
    import("./pages/changePassword").then((module) => ({
        default: module.ChangePasswordPage,
    }))
);
export const BusinessesPage = lazy(() =>
    import("././pages/businesses").then((module) => ({
        default: module.BusinessPage,
    }))
);
export const BusinessLandingPage = lazy(() =>
    import("./pages/business/market-prices.page").then((module) => ({
        default: module.MarketPrices,
    }))
);
export const SplitBuyDealsPage = lazy(() =>
    import("./pages/splitBuyDeals").then((module) => ({
        default: module.SplitBuyDealsPage,
    }))
);
export const MarketPricesPage = lazy(() =>
    import("./pages/market-prices/market-prices.page").then((module) => ({
        default: module.MarketPrices,
    }))
);
export const CommodityPricesPage = lazy(() =>
    import("./pages/commodity-prices/commodity-prices.page").then((module) => ({
        default: module.CommodityPricesPage,
    }))
);
export const AboutUsPage = lazy(() =>
    import("./pages/about-us/about-us.page").then((module) => ({
        default: module.AboutUsPage,
    }))
);
export const SplitBuyDealsSearchPage = lazy(() =>
    import("./pages/splitBuyDealsSearch").then((module) => ({
        default: module.SplitBuyDealsSearchPage,
    }))
);
export const SplitBuyDetailsPage = lazy(() =>
    import("./pages/splitBuyDetails").then((module) => ({
        default: module.SplitBuyDetailsPage,
    }))
);
export const ShoppingCartPage = lazy(() =>
    import("./pages/shoppingCart").then((module) => ({
        default: module.ShoppingCartPage,
    }))
);
export const CheckoutPage = lazy(() =>
    import("./pages/shoppingCart").then((module) => ({
        default: module.CheckoutPage,
    }))
);
export const OrderCompletePage = lazy(() =>
    import("./pages/shoppingCart").then((module) => ({
        default: module.OrderCompletePage,
    }))
);
export const SettingsPage = lazy(() =>
    import("./pages/settings").then((module) => ({
        default: module.SettingsPage,
    }))
);
// export const EmailPreferencesPage = lazy(() =>
//     import("./pages/email-preferences").then((module) => ({
//         default: module.EmailPreferencesPage,
//     }))
// );
export const SettingsSplitBuyHistoryPage = lazy(() =>
    import("./pages/settings").then((module) => ({
        default: module.SplitBuyHistorySubpage,
    }))
);
export const SettingsAddressManagementPage = lazy(() =>
    import("./pages/settings").then((module) => ({
        default: module.AddressManagementSubpage,
    }))
);
export const SettingsPasswordChangePage = lazy(() =>
    import("./pages/settings").then((module) => ({
        default: module.ChangePasswordSubpage,
    }))
);
export const SettingsPersonalInformationPage = lazy(() =>
    import("./pages/settings").then((module) => ({
        default: module.PersonalInformationSubpage,
    }))
);
export const SettingsReferAndEarnPage = lazy(() =>
    import("./pages/settings").then((module) => ({
        default: module.ReferAndEarnSubpage,
    }))
);
export const EmailPreferencesPage = lazy(() =>
    import("./pages/email-preferences").then((module) => ({
        default: module.EmailPreferencesPage,
    }))
);
export const GuestPage = lazy(() =>
    import("./pages/guest").then((module) => ({
        default: module.GuestPage,
    }))
);

export const RateOrderPage = lazy(() =>
    import("./pages/rate-order").then((module) => ({
        default: module.RateOrderPage,
    }))
);

export {
    Admin as AdminDashboardPage,
    AdminLoginPage,
    AdminSplitBuyPage,
    AdminSplitBuyPage as SplitBuyAdminPage,
    MarketingDashboardPage as AdminMarketingDashboardPage,
    OpsOrdersPage as AdminOpsOrdersPage,
    OpsOrdersUsersPage as AdminOpsOrdersUsersPage,
    OrderRatingsPage as AdminOrderRatingsPage,
    AdminSplitBuyDetailsPage,
    CommunicationsPage as AdminCommunicationsPage,
    BroadcastHistoryPage as AdminBroadcastHistoryPage,
    MarketingBuyersPage as AdminMarketingBuyersPage,
    BuyerDetailsPage as AdminBuyerDetailsPage,
    FarmsDirectoryPage as AdminFarmsDirectoryPage,
    OrderTransactionPage as AdminOrderTransactionPage,
    MarketPricesPage as AdminMarketPricesPage,
    MarketPriceHistoryPage as AdminMarketPriceHistoryPage,
} from "./pages/admin";
